export const EDIT_INPUT_TEST_ID = 'edit-input';
export const EDIT_BUTTON_TEST_ID = 'edit-button';
export const FAUX_EDIT_BUTTON_TEST_ID = 'faux-edit-button';
